import React from 'react'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'
import { checkIsActive } from '../../../../_helpers'
import { dashboardMenuList } from '../../../../../routes/Routes'
import { Icon } from '@material-ui/core'
import { useSelector } from 'react-redux'
import Badge from '@mui/material/Badge'
import NotificationsIcon from '@mui/icons-material/Notifications'

export function AsideMenuList({ layoutProps }) {
    const location = useLocation()

    const getMenuItemActive = (url, hasSubmenu = false) => {
        return checkIsActive(location, url)
            ? ` ${!hasSubmenu && 'menu-item-active'} menu-item-open `
            : ''
    }

    const { user } = useSelector(state => state.user)

    const styleATag = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    }

    // const userRole = user?.roles?.map((role) => role?.name);

    return (
        <>
            <ul className={`menu-nav ${layoutProps.ulClasses}`}>
                <li
                    className={`menu-item ${getMenuItemActive(
                        '/dashboard/',
                        true
                    )}`}
                    aria-haspopup="true"
                >
                    <NavLink
                        className="menu-link"
                        to="/dashboard/"
                        style={styleATag}
                    >
                        <Icon>dashboard</Icon>
                        {/* <span className="svg-icon menu-icon">
                            <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
                        </span> */}
                        <span className="menu-text px-1 text-gold">
                            داشبورد
                        </span>
                    </NavLink>
                </li>

                {dashboardMenuList.map(
                    item =>
                        item.role.some(
                            item => item === user?.roles[0]?.name
                        ) && (
                            <li
                                key={item.name}
                                className={`menu-item menu-item-submenu ${getMenuItemActive(
                                    item.path,
                                    true
                                )}`}
                                aria-haspopup="true"
                                data-menu-toggle="hover"
                            >
                                <NavLink
                                    className={`${
                                        item.sub && item.sub.length > 0
                                            ? 'menu-link menu-toggle'
                                            : 'menu-link'
                                    }`}
                                    to={item.path}
                                    style={styleATag}
                                >
                                    {item.icon ===
                                        'notifications_active_outlined' &&
                                    user.unSeenAnnouncement > 0 ? (
                                        <Icon>
                                            <Badge
                                                badgeContent={
                                                    user.unSeenAnnouncement
                                                }
                                                color="error"
                                                sx={{
                                                    '& .MuiBadge-badge': {
                                                        top: 5,
                                                        fontSize: 10,
                                                        height: 17,
                                                        width: 10,
                                                    },
                                                }}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <NotificationsIcon />
                                            </Badge>
                                        </Icon>
                                    ) : (
                                        <Icon>{item.icon}</Icon>
                                    )}

                                    <span className="menu-text px-1">
                                        {item.name}
                                    </span>
                                    {item.sub && item.sub.length > 0 && (
                                        <i className="menu-arrow"></i>
                                    )}
                                </NavLink>
                                {item.sub && item.sub.length > 0 && (
                                    <div className="menu-submenu">
                                        <ul className="menu-subnav">
                                            {item.sub.map(subMenu => (
                                                <li
                                                    key={subMenu.name}
                                                    className={`menu-item`}
                                                    aria-haspopup="true"
                                                >
                                                    <NavLink
                                                        className="menu-link"
                                                        to={subMenu.path}
                                                    >
                                                        <i className="menu-bullet menu-bullet-dot">
                                                            <span />
                                                        </i>
                                                        <span className="menu-text">
                                                            {subMenu.name}
                                                        </span>
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </li>
                        )
                )}
            </ul>
        </>
    )
}
